(function () {
  'use strict';

  const MODAL_ID = 'popup-newsletter__modal';
  const STORAGE_KEY = 'popup-newsletter-last-shown';

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initPopupNewsletter)
    : initPopupNewsletter();

  async function initPopupNewsletter() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) {
      console.error('[Popup Newsletter] Modal element not found!');
      return;
    }

    await waitForModalDefinition();

    const isDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;
    const showTarget = modal.getAttribute('data-show-target') || modal.getAttribute('data-show') || 'home';

    const delaySeconds = readNumericValue('popup-newsletter-data__delay', 10);
    const cooldownMinutes = readNumericValue('popup-newsletter-data__cooldown', 5);

    // 检查是否应该在当前页面显示
    if (!shouldShowOnCurrentPage(showTarget)) {
      modal.setAttribute('data-show', 'hidden');
      return;
    }

    // 检查 cooldown
    // cooldown <= 0 表示不需要冷却，可以直接显示
    // cooldown > 0 表示需要等待对应时间才能再次显示
    if (!isDesignMode && !cooldownSatisfied(cooldownMinutes)) {
      modal.setAttribute('data-show', 'hidden');
      return;
    }

    const triggerDisplay = () => {
      // 方法1: 尝试使用全局 API（如果存在）
      if (window.xoModal && typeof window.xoModal.open === 'function') {
        try {
          window.xoModal.open('popup-newsletter');
          if (!isDesignMode) {
            persistShownTimestamp();
          }
          return;
        } catch (error) {
          console.warn('[Popup Newsletter] window.xoModal.open failed:', error);
        }
      }

      // 方法2: 尝试使用 modal.show() 方法
      if (typeof modal.show === 'function') {
        try {
          modal.show();
          if (!isDesignMode) {
            persistShownTimestamp();
          }
          return;
        } catch (error) {
          console.warn('[Popup Newsletter] modal.show() failed:', error);
        }
      }

      // 方法3: 设置 data-show 属性（xo-modal 组件应该监听这个属性）
      modal.setAttribute('data-show', showTarget);

      // 方法4: 设置 xo-active 属性
      modal.setAttribute('xo-active', '');

      // 保存显示时间戳
      if (!isDesignMode) {
        persistShownTimestamp();
      }

      // 验证并重试
      setTimeout(() => {
        const isActive = modal.hasAttribute('xo-active');
        const dataShow = modal.getAttribute('data-show');

        // 如果还是没有显示，尝试强制触发
        if (!isActive && dataShow !== 'hidden') {
          // 尝试触发属性变化事件
          modal.removeAttribute('data-show');
          setTimeout(() => {
            modal.setAttribute('data-show', showTarget);
            modal.setAttribute('xo-active', '');

            // 如果还是不行，尝试 dispatch 自定义事件
            try {
              const event = new CustomEvent('xo-modal-open', { bubbles: true });
              modal.dispatchEvent(event);
            } catch (e) {
              // 静默失败
            }
          }, 100);
        }
      }, 300);
    };

    // delay = 0 表示立即显示
    // delay > 0 表示延迟对应秒数后显示
    if (!isDesignMode && delaySeconds > 0) {
      modal.setAttribute('data-show', 'hidden');
      window.setTimeout(triggerDisplay, delaySeconds * 1000);
    } else {
      triggerDisplay();
    }
  }

  function readNumericValue(id, fallback) {
    const el = document.getElementById(id);
    if (!el) {
      return fallback;
    }
    const text = el.textContent.trim();
    const parsed = Number(text);
    if (!Number.isFinite(parsed)) {
      return fallback;
    }
    return Math.max(0, parsed);
  }

  function shouldShowOnCurrentPage(showTarget) {
    if (showTarget === 'all') return true;
    if (showTarget === 'hidden') return false;
    if (showTarget === 'home') {
      const path = window.location.pathname.replace(/\/+$/, '') || '/';
      const isHome = path === '/' || path === '' || document.body.classList.contains('template-index');
      return isHome;
    }
    return false;
  }

  function cooldownSatisfied(cooldownMinutes) {
    // cooldown <= 0 表示不需要冷却，可以直接显示
    if (cooldownMinutes <= 0) {
      return true;
    }

    // cooldown > 0 表示需要等待对应时间才能再次显示
    const lastShown = getStoredTimestamp();
    if (!lastShown) {
      return true;
    }

    const elapsedMinutes = (Date.now() - lastShown) / 60000;
    return elapsedMinutes >= cooldownMinutes;
  }

  function getStoredTimestamp() {
    try {
      const value = localStorage.getItem(STORAGE_KEY);
      return value ? Number(value) : null;
    } catch (error) {
      console.warn('[Popup Newsletter] Storage unavailable:', error);
      return null;
    }
  }

  function persistShownTimestamp() {
    try {
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
    } catch (error) {
      console.warn('[Popup Newsletter] Failed to persist timestamp:', error);
    }
  }

  function waitForModalDefinition() {
    if (typeof customElements !== 'undefined' && customElements.whenDefined) {
      return customElements.whenDefined('xo-modal').catch(() => {
        return Promise.resolve();
      });
    }
    return Promise.resolve();
  }
})();
